import { createPopper } from '@popperjs/core';
import { useCallback, useMemo, useRef } from 'react';
import { noop } from './noop.js';
export function usePopper(options) {
    const trigger = useRef(null);
    const container = useRef(null);
    const cleanupCallback = useRef(noop);
    const instantiatePopper = useCallback(() => {
        if (!trigger.current)
            return;
        if (!container.current)
            return;
        if (cleanupCallback.current)
            cleanupCallback.current();
        cleanupCallback.current = createPopper(trigger.current, container.current, options).destroy;
    }, [trigger, container, cleanupCallback, options]);
    return useMemo(() => ({
        triggerRef: (triggerDomNode) => {
            ;
            trigger.current = triggerDomNode;
            instantiatePopper();
        },
        containerRef: (popperDomNode) => {
            ;
            container.current = popperDomNode;
            instantiatePopper();
        },
        rawTriggerRef: trigger,
        rawContainerRef: container
    }), [trigger, container, instantiatePopper]);
}
//# sourceMappingURL=usePopper.js.map